import React from 'react';

function ListViewIcon() {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0_6389_2696)'>
        <path
          d='M11.6673 2.86133V6.30345C11.6673 6.77016 11.6673 7.00351 11.7581 7.18177C11.838 7.33857 11.9655 7.46606 12.1223 7.54595C12.3006 7.63678 12.5339 7.63678 13.0007 7.63678H16.4428M11.6673 15.1367H6.66732M13.334 11.8034H6.66732M16.6673 9.29357V15.3034C16.6673 16.7035 16.6673 17.4036 16.3948 17.9384C16.1552 18.4088 15.7727 18.7912 15.3023 19.0309C14.7675 19.3034 14.0674 19.3034 12.6673 19.3034H7.33398C5.93385 19.3034 5.23379 19.3034 4.69901 19.0309C4.2286 18.7912 3.84615 18.4088 3.60647 17.9384C3.33398 17.4036 3.33398 16.7035 3.33398 15.3034V6.63672C3.33398 5.23659 3.33398 4.53652 3.60647 4.00174C3.84615 3.53134 4.2286 3.14889 4.69901 2.9092C5.23379 2.63672 5.93385 2.63672 7.33398 2.63672H10.0105C10.6219 2.63672 10.9277 2.63672 11.2154 2.70579C11.4705 2.76704 11.7143 2.86805 11.938 3.00512C12.1903 3.15972 12.4065 3.37591 12.8389 3.80829L15.4957 6.46515C15.9281 6.89753 16.1443 7.11372 16.2989 7.36601C16.436 7.58969 16.537 7.83355 16.5982 8.08864C16.6673 8.37636 16.6673 8.6821 16.6673 9.29357Z'
          stroke='#000'
          stroke-width='2'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_6389_2696'>
          <rect
            width='20'
            height='20'
            fill='white'
            transform='translate(0 0.96875)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ListViewIcon;
